import React from 'react'
// import Header from '../components/Header';
import Hero from '../components/Hero';
import TheModel from '../components/TheModel';
import ParticipationFramework from '../components/ParticipationFramework';
import Governance from '../components/Governance';
import ReputationViz from '../components/ReputationViz';
import Programs from '../components/Programs';
import Pricing from '../components/Pricing';
import Footer from '../components/Footer';
import WhoThrives from '../components/WhoThrives';

function Home() {
  return (
    <div style={{marginTop: "-73px"}} className="min-h-screen bg-white text-slate-900 selection:bg-slate-200 selection:text-slate-900">
      <main>
        <Hero />
        <TheModel />
        <ParticipationFramework />
        <Governance />
        <ReputationViz />
        <Programs />
        <Pricing />
        <WhoThrives />
      </main>
    </div>
  );
}

export default Home